import Api from '../http.service';

/**
 * get my with draw
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {Object} payload.data.filter
 * @param {String} payload.data.filter.requestAmount
 * @param {String} payload.data.filter.startDate
 * @param {String} payload.data.filter.endDate
 * @param {Number} payload.data.filter.withdrawTypeId
 */
export const myWithdrawRequest = (payload) =>
  Api.GET({
    url: `withdraw_request/me?size=${payload.itemPerPage}&page=${
      payload.pageNumber - 1
    }&where=${payload.data.filter}`,
  });

/**
 *insert with draw
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Number} payload.data.id
 * @param {String} payload.data.requestAmount
 * @param {String} payload.data.profileBankAccountId
 * @param {String} payload.data.description
 * @param {Number} payload.data.withdrawTypeId
 */
export const insert = (payload) =>
  Api.POST({
    url: `withdraw_request/me`,
    data: payload.data,
  });

/**
 * delete draw
 * @param {Object} payload
 * @param {String} payload.id
 */
export const remove = (id) =>
  Api.DELETE({
    url: 'withdraw_request',
    data: id,
  });
